/**
 * Step 10 (folder 11) — Trust / testimonials
 *
 * Spec: specs/onboarding-rebuild.md → Act 2 step 10
 *
 * PLACEHOLDER as of 2026-05-17 (Mason lock). Real testimonials fill in
 * when Illuminate has shipped to enough real users to collect honest
 * quotes. Until then, this step renders bracket-stub cards.
 *
 * Sits between Founder note (step 9) and Profile data (step 11) so the
 * brand block reads as one beat: founder (who) → testimonials (who else).
 */

import TrustSynthesis from './Trust.synthesis'

export default function TrustStep({ onContinue }) {
  return <TrustSynthesis onContinue={onContinue} />
}
